import { useTranslation } from 'react-i18next';

import { getKpiUniqueId } from '@/features/projects/shared/utils/kpi-utils';
import { getKpiUnitTranslationPlural } from '@/shared/hooks/use-kpi-unit-translation';
import { KpiWithMetrics } from '@/shared/types/api';
import { cn } from '@/shared/utils/cn';

export const KpiSelectionRow = ({
  kpis,
  currentKpi,
  setKpiId,
}: {
  kpis?: KpiWithMetrics[];
  currentKpi?: KpiWithMetrics;
  setKpiId: (kpiUniqueId: string) => void;
}) => {
  return (
    <KpiRowContainer>
      {kpis &&
        kpis.map((kpi) => (
          <KpiItem
            key={getKpiUniqueId(kpi)}
            kpi={kpi}
            isSelected={getKpiUniqueId(currentKpi) === getKpiUniqueId(kpi)}
            setKpiId={setKpiId}
          />
        ))}
    </KpiRowContainer>
  );
};

const KpiRowContainer = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="flex h-[52px] flex-row gap-6 overflow-x-auto rounded-xl bg-dark-container p-2 [scrollbar-width:none]">
      {children}
    </div>
  );
};

const KpiItem = ({
  kpi,
  isSelected,
  setKpiId,
}: {
  kpi: KpiWithMetrics;
  isSelected: boolean;
  setKpiId: (kpiUniqueId: string) => void;
}) => {
  const handleClick = async () => {
    setKpiId(getKpiUniqueId(kpi));
  };

  const { t: tKpiTypes } = useTranslation('kpiTypes', { nsMode: 'fallback' });

  return (
    <div
      onClick={handleClick}
      className={cn(
        'flex h-9 w-52 flex-shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors hover:bg-light-container',
        isSelected && 'bg-light-container',
        !isSelected && 'text-primary-shade-grey-500',
      )}
    >
      <span className="truncate px-3 text-2xs font-[510]">
        {kpi.name}
        <span className="text-primary-shade-grey-500">
          {' '}
          {getKpiUnitTranslationPlural(tKpiTypes, kpi.unit)}
        </span>
      </span>
    </div>
  );
};
